import { Fragment, useEffect, useState } from "react";


import ArticleDefault from 				"./Articles/ArticleDefault";
import ArticleText from 				"./Articles/ArticleText";
import ArticleCarousel from 			"./Articles/ArticleCarousel";


function ArticlePropagator( props ){

	const [component, setComponent] = useState(null);

	useEffect(() => {

		const sections = {
			default:					ArticleDefault,
			article_text:				ArticleText,
			article_carousel:			ArticleCarousel,
		};

		let Component = sections[ props.translation.content_display ] || ArticleDefault;

		setComponent( 
			<Component 
				key={`comp_${Math.random()}`} 
				article={props.translation} 
				articleIdx={props.articleIdx}
				{...props}
			/>
		);

	// eslint-disable-next-line
	}, [props.translation])

	// console.log("article", props)

	return (
		<Fragment>
		
			{/*<h6>-article-</h6>*/}
			
			{ component !== null && {...component} }

		</Fragment>
	);

}

export default ArticlePropagator;